var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"wrapper-container pa-12 pt-5",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('v-alert',{attrs:{"border":"top","colored-border":"","type":"info","elevation":"2"}},[_vm._v(" "+_vm._s(_vm.$t('in-progress'))+" ")])],1)],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }